module.exports = __webpack_public_path__ + "static/media/phuong.0a1e2e51.jpg";